import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=2187d56e&scoped=true"
import script from "./CategoryTable.vue?vue&type=script&lang=js"
export * from "./CategoryTable.vue?vue&type=script&lang=js"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=2187d56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187d56e",
  null
  
)

export default component.exports